__turbopack_context__.v({
  "root": "CreateWalletSeed-module__ZmDcla__root",
});
